import React from 'react'
import { IProps } from './index'
import { CTALink } from '../../elements/CTALink'

export const MutinyCtasContainer = ({ ctas }: IProps) => {
  return (
    <>
      {ctas &&
        ctas.map((cta, index) => (
          <div id={`mutiny-cta--${index}`} className="mutiny-cta-container__cta" key={index}>
            <CTALink {...cta} key={`mutiny-cta-link--${index}`} />
          </div>
        ))}
      <style jsx>
        {`
          .mutiny-cta-container__cta {
            display: none;
            min-width: 8.125rem;
            white-space: nowrap;
          }
        `}
      </style>
    </>
  )
}
